import styles from './SupplyDemand.css';
import { IconFunctionalHelpCircle16, Tooltip, UIHeading2, UIHeading4, UIText1 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { ReactElement } from 'react';
import { NBSP } from 'shared/constants/symbols';

type TDiffData = {
  text: string;
  icon: ReactElement | null;
};

interface ISupplyDemandParams {
  handleOpenTooltip?(): void;
  marketType: string;
  marketTypeDescription: string;
  supplyDiffData: TDiffData;
  demandDiffData: TDiffData;
  isInfoOpen: boolean;
  handleOpenInfo(): void;
  isDesktop: boolean;
}

export function SupplyDemand({
  isDesktop,
  handleOpenTooltip,
  marketType,
  supplyDiffData,
  demandDiffData,
  isInfoOpen,
  handleOpenInfo,
  marketTypeDescription,
}: ISupplyDemandParams) {
  const tooltipContent = (
    <div data-testid="supplyDemandTitleTooltipId" className={styles['content']}>
      <div className={styles['content-item']}>
        <UIText1>
          Спрос{NBSP}— по числу просмотров{NBSP}на{NBSP}одно объявление в{NBSP}течение месяца.
        </UIText1>
      </div>
      <UIText1>
        {' '}
        Предложение{NBSP}— по{NBSP}числу объявлений в{NBSP}этом и{NBSP}соседних домах.
      </UIText1>
    </div>
  );

  return (
    <div data-testid="supplyDemandId" className={styles['container']}>
      <div className={styles['tooltip-container']}>
        <Tooltip
          onOpen={handleOpenTooltip}
          header={`Как рассчитываем спрос и${NBSP}предложение`}
          title={tooltipContent}
          theme="white"
          placement="bottom-end"
        >
          <div data-testid="supplyDemandTooltipOnOpenId" className={styles['tooltip-item']}>
            <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading4}>
              {`Динамика спроса и${NBSP}предложения`}
            </ConditionalWrapper>
            <IconFunctionalHelpCircle16 color="gray_icons_100" />
          </div>
        </Tooltip>
      </div>
      <div className={styles['diff-content']}>
        <div className={styles['title']}>
          <UIHeading4>{marketType}</UIHeading4>
        </div>
        <div className={styles['diff-container']}>
          <div className={styles['diff-item']}>
            <UIText1 color="gray60_100">Спрос за год</UIText1>
            <div className={styles['diff-info']}>
              {demandDiffData.icon}
              <UIHeading2 color="primary_100">{demandDiffData.text}</UIHeading2>
            </div>
          </div>
          <div className={styles['diff-item']}>
            <UIText1 color="gray60_100">Предложение за год</UIText1>
            <div className={styles['diff-info']}>
              {supplyDiffData.icon}
              <UIHeading2 color="primary_100">{supplyDiffData.text}</UIHeading2>
            </div>
          </div>
        </div>
        <div className={styles['more-info']}>
          {!isDesktop && !isInfoOpen ? (
            <div
              onClick={handleOpenInfo}
              role="button"
              data-testid="supplyDemandMoreInfoBtnId"
              className={styles['more-btn']}
            >
              Что это значит
            </div>
          ) : (
            <UIText1>{marketTypeDescription}</UIText1>
          )}
        </div>
      </div>
    </div>
  );
}
